/* eslint-disable no-useless-catch */
import * as fetchService from '../../../../sharedmodules/services/fetch';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function pinSearch(getAccessToken, data) {

    const endPoint = `${basePath}/products/${encodeURIComponent(data.pin)}`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
            'content-type': 'application/json',
        },
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);
        return response.json();

    } catch (error) {

        throw error;

    }

}
